export default __webpack_public_path__ + "static/media/trash.437f4711.svg";